/**
 * <article-share-buttons> — article header actions (P11).
 *
 * Progressive enhancement only: the header renders complete without this file;
 * the buttons simply do nothing until it loads. No imports, no globals.
 *
 * - [data-article-action="print"]  opens the browser print dialog (recipes).
 * - [data-article-action="share"]  copies the page URL and shows the toast the
 *   section already rendered (hidden), so showing it changes no layout — the
 *   toast is absolutely positioned.
 */
class ArticleShareButtons extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-article-action]');
      if (!button) return;
      if (button.dataset.articleAction === 'print') {
        window.print();
        return;
      }
      this.copyLocation(button);
    });
  }

  async copyLocation(button) {
    const toast = button.querySelector('[data-share-toast]');
    try {
      await navigator.clipboard.writeText(window.location.href);
    } catch (error) {
      // Clipboard unavailable (permissions / non-secure context): fall back to
      // the native share sheet where one exists, otherwise give up quietly.
      if (navigator.share) {
        navigator.share({ url: window.location.href }).catch(() => {});
      }
      return;
    }
    if (!toast) return;
    toast.hidden = false;
    window.clearTimeout(this.toastTimer);
    this.toastTimer = window.setTimeout(() => {
      toast.hidden = true;
    }, 2000);
  }
}

if (!customElements.get('article-share-buttons')) {
  customElements.define('article-share-buttons', ArticleShareButtons);
}
